import React from 'react'
import { PasswordManagement, NewPasswordTextField, PasswordManagementForm } from 'password-and-session-management'
import { RenderOptions } from '../types'
import ReactiveSimulator from './ReactiveSimulator'

/**
 *
 */
const Content = (options: RenderOptions) => {
    if (options.component) {
        if (options.component.name === 'NewPassword') {
            return <ReactiveSimulator initialValue={options.component.props.value} onChange={options.component.props.onChange}>
                <NewPasswordTextField {...options.component.props} />
            </ReactiveSimulator>
        }

        if (options.component.name === 'PasswordManagementForm') {
            return <ReactiveSimulator initialValue={options.component.props.value} onChange={options.component.props.onChange}>
                <PasswordManagementForm {...options.component.props} />
            </ReactiveSimulator>
        }

        throw new Error(`Component: ${options.component.name} not supported. Available components: NewPassword, PasswordManagementForm`)
    }

    return <PasswordManagement
        logout={options.logout}
        onRedirectToLogin={options.onRedirectToLogin}
    />
}

export default Content
